import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  Image,
  StyleSheet,
} from "@react-pdf/renderer";

const Header = ({ institute, fromDate, toDate }) => (
  <View style={styles.header}>
    <View style={styles.logoContainer}>
      {institute?.instituteLogo && (
        <Image
          src={institute.instituteLogo}
          style={styles.logo}
        />
      )}
    </View>

    <View style={styles.titleContainer}>
      <Text style={styles.schoolName}>
        {institute?.instituteName}
      </Text>

      <Text style={styles.address}>
        {institute?.instituteAddress}
      </Text>

      <Text style={styles.contact}>
        Mob: {institute?.instituteMobileNo} | Email: {institute?.instituteEmail}
      </Text>

      <Text style={styles.title}>
        Transport Collection Report
      </Text>


    </View>
  </View>
);

const styles = StyleSheet.create({

  page: {
    padding: 20,
    fontSize: 10
  },


  header: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 18,
    borderBottomWidth: 1,
    borderBottomColor: "#cfcfcf",
    paddingBottom: 10,
  },

  logoContainer: {
    width: 80,
    justifyContent: "center",
    alignItems: "center",
  },

  titleContainer: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    paddingRight: 80, // balances the logo width
  },

  logo: {
    width: 65,
    height: 65,
    objectFit: "contain",
  },

  schoolName: {
    fontSize: 18,
    fontWeight: "bold",
  },

  address: {
    fontSize: 9,
    marginTop: 2,
  },
  head: {
    backgroundColor: "#eeeeee",
    fontWeight: "bold",
  },

  table: {
    display: "table",
    width: "100%",
    marginTop: 5,
    borderWidth: 0.5,
    borderColor: "#d3d3d3",
  },
  contact: {
    fontSize: 9,
    marginTop: 2,
  },

  title: {
    marginTop: 8,
    fontSize: 14,
    fontWeight: "bold",
  },

  subTitle: {
    marginTop: 4,
    fontSize: 10,
  },


  row: {
    flexDirection: "row",
    alignItems: "center",
  },



  cell: {
    padding: 4,
    fontSize: 10,
    textAlign: "center",
    justifyContent: "center",
    alignItems: "center",
    borderWidth: 0.5,
    borderColor: "#d3d3d3",
  }

});
const TransportCollectionReport = ({
  report,
  fromDate,
  toDate
}) => {
  const institute = report.institute;
  const groups = report.data;
  const grandTotal = report.grandTotal;


  return (

    <Document>

      <Page
        size="A4"
        style={styles.page}
      >

        <Header
          institute={institute}
          fromDate={fromDate}
          toDate={toDate}
        />
        {
          groups.map((group, index) => (

            <View key={index}>

              <Text style={styles.date}>
                Receipt Date : {group.paymentDate}
              </Text>

              <View style={styles.table}>

                <View style={[styles.row, styles.head]}>

                  <Text style={[styles.cell, { width: "6%" }]}>#</Text>

                  <Text style={[styles.cell, { width: "22%" }]}>
                    Student Name
                  </Text>

                  <Text style={[styles.cell, { width: "12%" }]}>
                    Class
                  </Text>

                  <Text style={[styles.cell, { width: "10%" }]}>
                    Months
                  </Text>

                  <Text style={[styles.cell, { width: "10%" }]}>
                    Amount
                  </Text>

                  <Text style={[styles.cell, { width: "10%" }]}>
                    Paid
                  </Text>

                  <Text style={[styles.cell, { width: "10%" }]}>
                    Discount
                  </Text>

                  <Text style={[styles.cell, { width: "10%" }]}>
                    Balance
                  </Text>

                  <Text style={[styles.cell, { width: "10%" }]}>
                    Mode
                  </Text>

                </View>

                {
                  group.payments.map((student, i) => (

                    <View
                      key={i}
                      style={styles.row}
                    >

                      <Text style={[styles.cell, { width: "6%" }]}>
                        {i + 1}
                      </Text>

                      <Text style={[styles.cell, { width: "22%" }]}>
                        {student.studentName}
                      </Text>

                      <Text style={[styles.cell, { width: "12%" }]}>
                        {student.className}
                      </Text>

                      <Text style={[styles.cell, { width: "10%" }]}>
                        {student.numberOfMonths}
                      </Text>

                      <Text style={[styles.cell, { width: "10%" }]}>
                        {student.amount}
                      </Text>

                      <Text style={[styles.cell, { width: "10%" }]}>
                        {student.paidAmount}
                      </Text>

                      <Text style={[styles.cell, { width: "10%" }]}>
                        {student.discount}
                      </Text>

                      <Text style={[styles.cell, { width: "10%" }]}>
                        {student.balance}
                      </Text>

                      <Text style={[styles.cell, { width: "10%" }]}>
                        {student.modeOfPayment}
                      </Text>

                    </View>

                  ))
                }

              </View>

              <View
                style={{
                  alignItems: "flex-end",
                  marginTop: 5
                }}
              >

                <Text
                  style={{
                    fontWeight: "bold"
                  }}
                >

                  Group Total : {group.totalAmount}

                </Text>

              </View>

            </View>

          ))
        }

        <View
          style={{
            marginTop: 20,
            alignItems: "flex-end"
          }}
        >

          <Text
            style={{
              fontWeight: "bold",
              fontSize: 12
            }}
          >

            Grand Total : {grandTotal}

          </Text>

        </View>

      </Page>

    </Document>

  );

};

export default TransportCollectionReport;